import useCommonApi from "../api/useCommonApi";

const useGuiaEtiquetasPdf = () => {
    const api = useCommonApi();

    const obtenerEtiquetasPdfBase64 = async (guiaId: number): Promise<string> => {
        if (!guiaId || guiaId <= 0) {
            throw new Error("GuiaId inválido.");
        }
        return await api.postAsync<string>(`guia/guia-etiquetas-pdf/${guiaId}`);
    };

    return { obtenerEtiquetasPdfBase64 };
};

export default useGuiaEtiquetasPdf;
